import React from 'react';

import isArray from 'lodash/isArray';

import { formatCaptureDeadline } from './preauthUtils';
import { PreAuthWithSale } from './types';

type OtherPreauthsProps = {
  preauths: PreAuthWithSale[];
};

function getSalesLinesBody(preauth: PreAuthWithSale) {
  const saleLine = preauth.sale?.SaleLines?.SaleLine || [];
  const saleLines: SaleLine[] = isArray(saleLine) ? saleLine : [saleLine];

  if (!saleLines || saleLines.length <= 0) {
    return (
      <tr>
        <td colSpan={7} style={{ textAlign: 'center', padding: '20px' }}>
          No transaction lines found
        </td>
      </tr>
    );
  }

  return saleLines.map((line) => {
    const discount = line.Discount?.discountAmount ? parseFloat(line.Discount.discountAmount) : 0;

    return (
      <tr className="preauth-line-row" data-line-id={line.saleLineID}>
        <td>
          <span>{line.Item?.description}</span>
        </td>
        <td className="money">${parseFloat(line.unitPrice).toFixed(2)}</td>
        <td className="center">{parseFloat(line.unitQuantity).toFixed(0)}</td>
        <td className="money">${discount.toFixed(2)}</td>
        <td className="center">{line.tax ? 'Yes' : 'No'}</td>
        <td className="money">${parseFloat(line.calcTotal).toFixed(2)}</td>
        <td />
      </tr>
    );
  });
}
const OtherPreauths: React.FC<OtherPreauthsProps> = ({ preauths }) => {
  const handleProcessAuth = (saleRef: string) => {
    window.location.href = `/register.php?form_name=load_transaction&transaction_id=${saleRef}`;
  };

  if (preauths.length === 0) {
    return null;
  }
  return (
    <div style={{ borderTop: '1px solid #ccc', paddingTop: '20px', marginTop: '20px' }}>
      <h3 style={{ margin: '0 0 20px 30px', fontSize: '24px', fontWeight: 'bold', color: '#333' }}>
        Other preauthorizations
      </h3>
      {preauths.map((preauth) => (
        <div
          key={preauth.transactionId}
          className="register-modal"
          style={{ marginBottom: '20px' }}
        >
          <div style={{ borderBottom: '1px solid #ccc' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                padding: '20px 20px 15px 20px',
              }}
            >
              <div>
                <h4
                  style={{
                    margin: '0 0 8px 0',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: '#333',
                  }}
                >
                  Sale #{preauth.saleRef}
                </h4>
                <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
                  Capture deadline: {formatCaptureDeadline(preauth.captureDeadline)}
                </p>
              </div>
              <button
                type="button"
                className="cr-button cr-button--large"
                style={{
                  padding: '10px 20px',
                  fontSize: '14px',
                  whiteSpace: 'nowrap',
                  background: 'linear-gradient(180deg, #FFFFFF 0%, #F2F5F8 100%)',
                  border: '1px solid #BCC4CA',
                  borderRadius: '3px',
                }}
                onClick={() => handleProcessAuth(preauth.saleRef)}
              >
                <span className="cr-button__content">Process authorization</span>
              </button>
            </div>

            <table className="register-listing" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>DESCRIPTION</th>
                  <th className="th-money">PRICE</th>
                  <th style={{ width: '60px' }}>QTY.</th>
                  <th className="th-money" style={{ width: '80px' }}>
                    DISCOUNT
                  </th>
                  <th style={{ width: '60px' }}>TAX</th>
                  <th className="th-money" style={{ width: '120px' }}>
                    AUTHORIZE AMOUNT
                  </th>
                  <th style={{ width: '120px' }} />
                </tr>
              </thead>
              <tbody>{getSalesLinesBody(preauth)}</tbody>
              <tfoot>
                <tr style={{ borderTop: '1px solid #ccc' }}>
                  <td style={{ padding: '15px 10px' }} />
                  <td
                    colSpan={5}
                    style={{
                      textAlign: 'right',
                      fontWeight: 'bold',
                      padding: '15px 5px 15px 10px',
                      fontSize: '16px',
                    }}
                  >
                    Total authorized:
                  </td>
                  <td
                    className="money"
                    style={{
                      fontWeight: 'bold',
                      padding: '15px 0 15px 5px',
                      fontSize: '16px',
                    }}
                  >
                    ${preauth.amount?.amount}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OtherPreauths;
